@if (show()) {
  <div class="grace-banner" role="alert">
    <span class="banner-text">
      {{ 'subscription.gracePeriodBanner' | translate : { date: periodEndsAt() | date:'mediumDate' } }}
    </span>
    <a routerLink="/pricing" mat-button class="reactivate-link">
      {{ 'subscription.reactivate' | translate }}
    </a>
    <button mat-icon-button class="dismiss-btn" (click)="dismiss()" [attr.aria-label]="'common.dismiss' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
